<template>
	<div>{{ row[ field.slug ] }}</div>
</template>

<script>

export default {

	props: [ 'row', 'field' ],

};
</script>
